import React, { forwardRef, useImperativeHandle, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Typography,
  Flex,
  message,
  Select,
  Radio,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const ResetModal = forwardRef((props, ref) => {
  const { onSuccess } = props;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [openLoading, setOpenLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [showJob, setShowJob] = useState(false);

  const [jobtypelist, setJobTypeList] = useState([]);
  const [accDictList, setAccDictList] = useState([]);

  const [currentRecord, setCurrentRecord] = useState(null);

  const loadJobTypeList = async () => {
    const response = await http.get(api.getjobTypeshow);
    const data = (response.data || []).map((item) => ({
      value: item.id,
      label: item.name,
    }));
    setJobTypeList(data);
  };

  const loadAccDictList = async () => {
    const response = await http.get(api.getAcctDictList, {
      params: { glChartNameId: "1" },
    });

    const list = (response.data || []).map((item) => ({
      value: item.glAcct,
      label: item.glAcctTitle,
    }));

    setAccDictList(list);
  };

 
  useImperativeHandle(ref, () => ({
    open: async (record) => {
      setVisible(true);
      setOpenLoading(true); 

      setCurrentRecord(record);
      form.resetFields();
      setShowJob(record.parentId !== 0);

      // 加载下拉数据
      await Promise.all([loadJobTypeList(), loadAccDictList()]);

      // 设置初始值
      form.setFieldsValue({
        name: record.name,
        description: record.description,
        level: record.parentId === 0 ? "level1" : "level2",
        jobid: record.parentId === 0 ? null : record.parentId,
        glMonthlyWorker: record.glMonthlyWorker,
        glContractor: record.glContractor,
        monthlyWorkerV: record.monthlyWorkerV,
        contractorV: record.contractorV,
      });

    
      setOpenLoading(false);
    },
  }));

  /** 提交 */
  const onFinishAdd = async (values) => {
    try {
      setLoading(true);

      const queryParams = {
        id: currentRecord?.id,
        name: values.name,
        description: values.description,
        parentId: values.level === "level1" ? 0 : values.jobid,
        glMonthlyWorker: values.glMonthlyWorker,
        glContractor: values.glContractor,
        monthlyWorkerV: values.monthlyWorkerV,
        contractorV: values.contractorV,
        updateBy: localStorage.getItem("accountId"),
      };

      const response = await http.post(api.getjobtypeupdate, queryParams);
      const res = response?.data || response;

      if (String(res.code) === "1") {
        message.success("Update job successfully");
        setVisible(false);
        form.resetFields();
        onSuccess && onSuccess();
      } else {
        message.error(res.msg || "Update failed");
      }
    } catch (error) {
      message.error("Submit error, try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start">
          <EditOutlined style={{ marginRight: 10 }} />
          <Typography.Title level={4}>EDIT JOB TYPE</Typography.Title>
        </Flex>
      }
      width="60%"
      open={visible}
      confirmLoading={openLoading}
      maskClosable={false}
      onCancel={() => {
        setVisible(false);
        setShowJob(false);
        form.resetFields();
      }}
      footer={
         <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>
      }
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              form={form}
              name="editJobForm"
              onFinish={onFinishAdd}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 16 }}
            >
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter a name" }]}
              >
                <Input allowClear />
              </Form.Item>

              <Form.Item
                name="description"
                label="Description"
              >
                <Input allowClear />
              </Form.Item>

              {/* <Form.Item name="level" label="Level">
                <Radio.Group
                  onChange={(e) => setShowJob(e.target.value === "level2")}
                >
                  <Radio value="level1">Level 1</Radio>
                  <Radio value="level2">Level 2</Radio>
                </Radio.Group>
              </Form.Item> */}

              {showJob && (
                <Form.Item
                  name="jobid"
                  label="Job Type"
                  rules={[
                    { required: true, message: "Please select job type" },
                  ]}
                >
                  <Select
                    placeholder="Select job type"
                    options={jobtypelist}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                  />
                </Form.Item>
              )}

              <Form.Item name="glMonthlyWorker" label="GL Monthly Worker">
                <Select
                  placeholder="Select glMonthlyWorker"
                  options={accDictList}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>

              <Form.Item name="glContractor" label="GL Contractor">
                <Select
                  placeholder="Select glContractor"
                  options={accDictList}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>

              <Form.Item name="monthlyWorkerV" label="Monthly Worker V">
                <Select
                  placeholder="Select monthlyWorkerV"
                  options={accDictList}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>

              <Form.Item name="contractorV" label="Contractor V">
                <Select
                  placeholder="Select contractorV"
                  options={accDictList}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default ResetModal;
